// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ae201dd4","900":"cc283fcf"}[chunkId] + ".chunk.js";
};